(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group-video-slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const button = event.target.closest('.video-slide__play');
  if (!button || !button.closest('.section-group__container')) return;

  const container = button.closest('.video-slide__video');
  const video = container.querySelector('video');
  const icon = container.querySelector('.video-slide__play__btn');

  if (video.paused) {
    video.play();
    icon.style.display = 'none';
  } else {
    video.pause();
    icon.style.display = '';
  }
});
  } catch(e) { console.error(e); }
})();

})();
